<template>
  <div class="public-floating-ctas" aria-label="Retailer actions">
    <a href="/retailer" class="floating-cta">
      <svg viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true">
        <polygon points="12 2.5 15.09 8.9 22.18 9.9 17.09 14.8 18.27 21.9 12 18.6 5.73 21.9 6.91 14.8 1.82 9.9 8.91 8.9" />
      </svg>
      Become a Retailer
    </a>
    <a href="https://calendly.com/russ-ucari" target="_blank" rel="noopener" class="floating-cta-calendly">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <rect x="3" y="4" width="18" height="18" rx="2.4" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </svg>
      Schedule a Call + Free Kit
    </a>
  </div>
</template>

<script>
export default {
  name: 'PublicFloatingCtas',
};
</script>
